function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "89",
  height: "89",
  viewBox: "0 0 89 89",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M33 69a7 7 0 100-14 7 7 0 000 14zM65 66a4 4 0 100-8 4 4 0 000 8zM26 36a3 3 0 100-6 3 3 0 000 6z",
  stroke: "currentColor",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_8371_43236)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M72.65 36.65c-1.19.25-2.42.38-3.69.38-9.96 0-18.04-8.08-18.04-18.04 0-1.26.13-2.5.38-3.69-5.53-2.6-9.52-7.92-10.25-14.24C18.68 2.58 1 21.19 1 43.95s19.25 43 43 43S85.37 69.27 86.89 46.9c-6.32-.73-11.64-4.72-14.24-10.25z",
  stroke: "currentColor",
  strokeWidth: "2"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: "2",
  d: "M84.094 5.092L65.709 23.477M83.68 23.092L65.295 4.707"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_8371_43236"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h87.95v87.95H0z"
})))));